/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2022 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import { getProvider } from "./provider.js";
/**
 * Return a set of random bytes
 */
export const randomBytes = (bytesCount) => getProvider().randomProvider.randomBytes(bytesCount);
